<script setup lang="ts">
defineOptions({
  errorCaptured(err: Error) {
    const service = (this as any).$imodal;
    if (service?.manager) {
      service.manager.errorCaptured(err);
    }
    return false;
  },
});
</script>

<template>
  <portal-target name="imodal" :multiple="true" />
</template>
